import React, { useEffect, useCallback, useState } from 'react';
import Breadcrumbs from './Breadcrumbs/Breadcrumbs';
import { FeatureFlag, LocalPersistence } from '../factories/index';
import FlagsComponent from '@ui/Flags';
import { fetcher } from '@helpers/utils';

type propertyConnectorType = {
  showBreadcrubms?: boolean;
};

const Header = ({ showBreadcrubms = true }: propertyConnectorType) => {
  const [languages, setLanguages] = useState([]);

  const isFlaggedComponent = () => {
    const languagePicker = new FeatureFlag(
      process.env.REACT_APP_LANGUAGE_PICKER
    );
    if (['/listing', ''].includes(window.location.pathname)) return null;
    if (languages.length === 0) return null;
    return languagePicker.renderFlaggedComponent({
      component: () => <FlagsComponent langs={languages} />,
    });
  };

  const propertyConnectorContent = () => (
    <div className="breadcrumbs">
      <div className="sub_container">
        <h3 className="main_title">
          <a href="/property-connector">Property Connector</a>
        </h3>
        <h1 className="sub_title"> by DERBYSOFT </h1>
      </div>
    </div>
  );

  const getAvailableLangs = useCallback(async () => {
    const get_session = new LocalPersistence('session');
    const session = await get_session.getSessionPersistence();
    if (!session) return null;
    const { propertyId, supplier } = session;
    const langData = await fetcher({
      url: `/language?supplier=${supplier}&propertyid=${propertyId}`,
      options: {
        method: 'GET',
      },
    });

    return setLanguages(langData);
  }, []);

  useEffect(() => {
    getAvailableLangs();
  }, []);

  return (
    <div id="header">
      {showBreadcrubms ? <Breadcrumbs /> : propertyConnectorContent()}
      {isFlaggedComponent()}
    </div>
  );
};

export default Header;
